(function () {
  'use strict';

  function parseCards(markup, kind) {
    var documentFragment = new DOMParser().parseFromString(markup, 'text/html');
    var response = documentFragment.querySelector('[data-recommendation-response="' + kind + '"]');
    return response ? Array.from(response.querySelectorAll('[data-product-card]')) : [];
  }

  function loadBand(section, kind, url) {
    if (!url) return Promise.resolve(false);
    return fetch(url, { headers: { Accept: 'text/html' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Recommendation request failed');
        return response.text();
      })
      .then(function (markup) {
        var sourceProductId = section.getAttribute('data-product-id');
        var cards = parseCards(markup, kind).filter(function (card) {
          return card.getAttribute('data-product-id') !== sourceProductId;
        }).slice(0, 4);
        if (!cards.length) return false;

        var band = section.querySelector('[data-recommendation-band="' + kind + '"]');
        var grid = section.querySelector('[data-recommendation-grid="' + kind + '"]');
        cards.forEach(function (card) { grid.appendChild(card); });
        band.hidden = false;
        return true;
      })
      .catch(function () { return false; });
  }

  document.querySelectorAll('[data-product-recommendations]').forEach(function (section) {
    Promise.all([
      loadBand(section, 'related', section.getAttribute('data-related-url')),
      loadBand(section, 'vendor', section.getAttribute('data-vendor-url'))
    ]).then(function (results) {
      if (results.some(Boolean)) section.hidden = false;
    });
  });
})();
